import React, { useState } from "react";
import { ReactComponent as ExpandIcon } from "Assets/Icons/Leaderboard/ExpandIcon.svg";
import { ReactComponent as CollapseIcon } from "Assets/Icons/Leaderboard/CollapseIcon.svg";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid2,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";

const ContestInstructions = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Accordion
      elevation={0}
      bordered
      expanded={isOpen}
      onChange={() => setIsOpen(!isOpen)}
    >
      <AccordionSummary
        expandIcon={
          <IconButton filled>
            {" "}
            <PrimaryIcon
              color="white"
              icon={isOpen ? CollapseIcon : ExpandIcon}
              width="16px"
              height="16px"
            />{" "}
          </IconButton>
        }
      >
        <Typography
          display={"flex"}
          alignItems={"center"}
          gap="10px"
          fontWeight={500}
          variant="subtitle"
        >
          <PrimaryIcon icon={AlertIcon} width="20px" height="20px" /> Test
          Instructions
        </Typography>{" "}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box>
          <Typography fontWeight={500} variant="subtitle">
            General
          </Typography>
          <Typography mt="5px" mb="5px" color="secondary.light">
            This is a timed test. Please keep track of the time remaining at the
            top of the page
          </Typography>
          <Typography color="secondary.light">
            If you feel the question is unclear, try out different inputs and
            check the expected output for each of them.
          </Typography>
        </Box>
        <Box>
          <Typography fontWeight={500} variant="subtitle">
            Code Implementation
          </Typography>
          <Typography mt="5px" mb="5px" color="secondary.light">
            1. You only need to implement the given function. Do not read input;
            instead use the arguments to the function. Do not print the output;
            instead return values as specified. Still have a question? Check out
          </Typography>
        </Box>
        <Box>
          <Typography fontWeight={500} variant="subtitle">
            Plagiarism
          </Typography>
          <Typography mt="5px" mb="5px" color="secondary.light">
            Your code submission will be checked for plagiarism after you're
            finished. If the code is found to be similar to another, it will be
            reported as appropriate.
          </Typography>
          <Typography color="secondary.light">
            To prevent plagiarism, we discourage switching tabs or windows
            during the test. Any such activity will be recorded and will be
            available for the company contact to see.
          </Typography>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default ContestInstructions;
